<Modal
  title="Are you sure?"
  {isLoading}
  on:close={() => ($uiState.activeModal = undefined)}
  on:action={() => apply()}>
  End the offer. The offer will be unpublished and marked as ended. Any requests that are not selected, matched or withdrawn will be marked as unsuccessful and the charities will be notified.

  {#if errorMessage}
    <div class="notification is-danger is-light">{errorMessage}</div>
  {/if}
</Modal>

<script lang="ts">
  export let item : Offer_v2_Doc;

  import { logging } from '../../../../../lib/logging';
  import { uiState } from "../../../../../lib/uiState";
  import Modal from "../../../../_components/Modal.svelte";

  let errorMessage : string;
  let isLoading = false;

  async function apply() {
    let firebase = window.firebase;

    isLoading = true;

    await firebase
      .functions()
      .httpsCallable('api-offer-closeoffer')({ id: item.id } as CloseOfferParams)
      .catch((err) => {
        logging.report(err.toString());
        errorMessage = err;
      })
      .finally(() => (isLoading = false));

    $uiState.activeModal = undefined;
    
  }
</script>
